import React from 'react';

// Compact "To: chip chip chip" / "Cc: chip chip chip" row used inside
// email/reminder dialogs so the admin can see at a glance who's on the
// recipient list and remove anyone with one tap.
//
// Extracted from AdminInvoiceDetail.jsx so both the invoice email dialog
// AND the "Chase overdue" dialog on CustomerDetail can share the same UI.
const RecipientStack = ({ label, emails, onRemove, accent, testid }) => {
  const accentMap = {
    emerald: 'bg-emerald-50 border-emerald-200 text-emerald-800 hover:bg-emerald-100',
    amber: 'bg-amber-50 border-amber-200 text-amber-800 hover:bg-amber-100',
  };
  const tone = accentMap[accent] || accentMap.emerald;
  return (
    <div className="flex flex-wrap items-center gap-1.5 min-h-[34px] py-1" data-testid={testid}>
      <span className="text-[10px] uppercase tracking-wider text-slate-500 font-semibold w-7 shrink-0">
        {label}
      </span>
      {emails.length === 0 && (
        <span className="text-xs text-slate-400 italic">— none —</span>
      )}
      {emails.map((e) => (
        <button
          key={e}
          type="button"
          onClick={() => onRemove(e)}
          className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full border text-xs transition-colors ${tone}`}
          title={`Remove ${e}`}
          data-testid={`${testid}-chip-${e}`}
        >
          <span className="font-medium truncate max-w-[200px]">{e}</span>
          <span aria-hidden="true" className="text-base leading-none -mt-0.5">×</span>
        </button>
      ))}
    </div>
  );
};

export default RecipientStack;
export { RecipientStack };
